@if (isContractCreated === true) {
<div class="contract-summary">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }
  <div class="contract-created-card">
    <div class="contract-created-content">
      <h1>{{ 'TRANSLATE.CONGRATULATIONS' | translate }}</h1>
      <h3>
        {{ 'TRANSLATE.YOU.HAVE.JUST.PURCHASED.FORD.PROTECT' | translate }}
      </h3>
      <h3>
        {{ 'TRANSLATE.NEXT.YOU.CAN.ACCESS.CONTRACT.TEXT' | translate }}
      </h3>
      <h3>
        {{ 'TRANSLATE.THANK.YOU.AND.COUNT.ON.US' | translate }}
      </h3>
    </div>
    <div class="col-12 md:col-12 lg:col-12 button-position contract-created-action">
      <button id="btnDownload" class="btn-download contract-created-download" type="button"
        [disabled]="isDownloadingContract" [ngClass]="{ 'is-loading': isDownloadingContract }"
        [attr.aria-busy]="isDownloadingContract" (click)="downloadPDF()">
        @if (!isDownloadingContract) {
        <i class="pi pi-download" aria-hidden="true"></i>
        }
        @if (isDownloadingContract) {
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        }
        <span class="btn-download-span">{{ (isDownloadingContract ? 'TRANSLATE.DOWNLOADING.TERMS.OF.AGREEMENT' :
          'TRANSLATE.DOWNLOAD.TERMS.OF.AGREEMENT') | translate }}</span>
      </button>
    </div>
  </div>
</div>
}

@if (isContractCreated === false) {
<div class="contract-summary">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }
  <div class="contract-wrapper">
    <div class="col-11 md:col-12 lg:col-12 page-content">
      <div class="col-12 md:col-12 lg:col-12 image-position">
        <img style="width: 380px; height: 80px;" src="../../../assets/image/FordProtect_Blue_RGB_Hz_v1.png" alt="">
      </div>
      <div class="col-12 text-content">
        <h4 class="styling-the-title">TERMO DE ADESÃO AO PLANO DE MANUTENÇÃO PRÉ-PAGA FORD PROTECT</h4>
        <hr class="styling-the-hr" />
      </div>
      <div class="col-12 top-element">
        <div class="header">
          <h5 class="header-title">CONTRATANTE</h5>
        </div>
        <div class="info-box top-box">
          <div class="first-line">
            <h5 class="bold-words">NOME:</h5>
            <p>{{ completeName }}</p>
          </div>
          <div class="first-line">
            <h5 class="bold-words">{{ documentLabel }}</h5>
            <p>{{ maskCpfCnpj }}</p>
          </div>
          <div class="first-line">
            <h5 class="bold-words">ENDEREÇO:</h5>
            <p [innerHTML]="fullAddressFormatted"></p>
          </div>
          <div class="first-line-position">
            <div class="first-line">
              <h5 class="bold-words">TELEFONE:</h5>
              <p>{{ phoneMask }}</p>
            </div>
            <div class="first-line space">
              <h5 class="bold-words">E-MAIL:</h5>
              <p>{{ clientData?.email1.toLowerCase() }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 top-element">
        <div class="header">
          <h5 class="header-title">CONCESSIONÁRIA</h5>
        </div>
        <div class="info-box top-box-second">
          <div class="elements-below-each-other">
            <div class="first-line">
              <h5 class="bold-words">RAZÃO SOCIAL:</h5>
              <p>{{ dealerName }}</p>
            </div>
            <div class="first-line">
              <h5 class="bold-words">CNPJ:</h5>
              <p>{{ dealerMaskCnpj }}</p>
            </div>
            <div class="first-line">
              <h5 class="bold-words">ENDEREÇO:</h5>
              <p [innerHTML]="dealerFullAddressFormatted"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 top-element">
        <div class="header">
          <h5 class="header-title">DADOS DO VEÍCULO</h5>
        </div>
        <div class="info-box top-box-third">
          <div class="first-line-position">
            <div class="first-line">
              <i class="fas fa-solid fa-car-side icon-style"></i>
            </div>
            <div class="first-line space-car-image">
              <h5 class="bold-words">VEÍCULO:</h5>
              <p>{{ vinValidate.modelName.toUpperCase() }}</p>
            </div>
            <div class="first-line space-car-image-second">
              <h5 class="bold-words">CHASSI:</h5>
              <p>{{ vinValidate.vin }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 top-element">
        <div class="header">
          <h5 class="header-title">PLANO E VALOR</h5>
        </div>
        <div class="info-box top-box-fourth">
          <div class="first-line-position">
            <div class="first-line">
              <i class="fas fa-regular fa-dollar-sign icon-style"></i>
            </div>
            <div class="first-line space-sifron-image">
              <p>
                O plano contratado é o {{ choosePlanBuyng.maintenance.planName }},
                cujo preço é de R$ {{ choosePlanBuyng.totalPrice | currency: 'R$:' }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 top-element">
        <p class="contract-paragraph">
          Pelo presente instrumento particular, o <span class="bold-words">CONTRATANTE</span> adere, através da
          <span class="bold-words">CONCESSIONÁRIA</span>,
          neste ato, ao Plano de
          Manutenção Pré-Paga denominado “Ford Protect” (“Termo de Adesão”) idealizado pela <span
            class="bold-words">FORD MOTOR COMPANY
            BRASIL LTDA.</span>, com sede na cidade de São Paulo, Estado de São Paulo, na Avenida Doutor Cardoso
          de Melo, nº 1336,
          térreo, Vila
          Olímpia, CEP: 04548-004, inscrita no CNPJ/MF sob nº 03.470.727/0004-73 e com uma de suas filiais
          estabelecida na
          Avenida Prefeito João Vilallobo Quero, nº 2237/2253, Sítio Pedra Rachada/Belval, na cidade de Barueri,
          Estado de São
          Paulo, CEP: 06422-122, inscrita no CNPJ/MF sob nº 03.470.727/0012-83 (“<span class="bold-words">FORD</span>”),
          para proprietários de
          veículos da marca <span class="bold-words">FORD</span>.
        </p>

        <p class="contract-paragraph">
          O Ford Protect tem por objeto a realização de revisões periódicas ou serviços de manutenção específicos,
          levando em consideração (i) a periodicidade recomendada; ou (ii) a quilometragem do veículo (km
          rodados);
          ou (iii) se equipado, a indicação do Monitor Inteligente de Vida Útil do Óleo (IOLM), sendo o que
          ocorrer
          primeiro, condições previstas no Manual do Proprietário.
        </p>

        <p class="contract-paragraph">
          As revisões periódicas, ora contratadas por meio do presente instrumento, contemplam a troca de óleo do
          motor, do fluido de freio e a substituição das seguintes peças: filtro de óleo do motor, filtro de
          combustível, elemento do
          filtro de ar do motor, elemento do filtro de pólen da caixa de ventilação e velas de ignição.
          Ressalta-se que
          a substituição abrangerá apenas os itens especificamente indicados no plano de manutenção de cada
          respectiva revisão.
        </p>
        <p class="contract-paragraph">
          As revisões incluem também a mão de obra para todas as inspeções e checagens previstas na tabela de
          Manutenção e Lubrificação do Manual do Proprietário, correspondente a cada uma das revisões.
        </p>

        <p class="contract-paragraph">
          Para o plano exclusivo de troca de Óleo e Filtro, o serviço contempla a substituição do óleo do motor
          e do filtro de óleo, não incluindo os demais itens ou as checagens de inspeção de uma revisão completa.
        </p>

        <p class="contract-paragraph">
          A presente adesão confere, gratuitamente, o benefício de 12 (doze) ou 24 (vinte e quatro) meses do
          Programa Ford Assistance (dependendo do plano contratado), respeitados os termos e condições
          estabelecidos no Manual do Proprietário do Veículo. Uma vez que os veículos 0km já são cobertos com 12
          (doze) meses de Programa Ford Assistance, a adesão ao Ford Protect aumentará o prazo de vigência do
          Programa Ford Assistance de acordo com o plano contratado. Para veículos usados que estão fora do
          período de cobertura do Programa Ford Assistance original de 12 (doze) meses, o prazo de cobertura será
          o pertinente ao plano contratado.
        </p>

        <p class="contract-paragraph">
          Os planos disponíveis para adesão são:
        </p>

        <p class="contract-paragraph">
          <span class="bold-words"> Ford Protect Revisões Pré-Adquiridas: </span> inclui as revisões periódicas do
          Veículo, conforme a quantidade contratada, observando-se que, para o plano Basic, o cliente fará jus ao
          benefício de 12 (doze) meses do Programa
          Ford Assistance e, para o plano Plus, fará jus ao benefício de 24 (vinte e quatro) meses;
        </p>
        <p class="contract-paragraph">
          <span class="bold-words"> Ford Protect Óleo e Filtro: </span> inclui os serviços de substituições
          consecutivas de
          óleo e filtro de óleo do motor, conforme a quantidade prevista no plano contratado;
        </p>
        <p class="contract-paragraph">
          <span class="bold-words"> Ford Protect Manutenção Premium (2 anos, 3 revisões ou 60.000 Km): </span>
          inclui as 3 (três) primeiras revisões periódicas do Veículo e a substituição de peças de desgaste
          natural;
        </p>
        <p class="contract-paragraph">
          <span class="bold-words"> Ford Protect Manutenção Premium (2 anos, 4 revisões ou 80.000 Km): </span>
          inclui as 4 (quatro) primeiras revisões periódicas do Veículo e a substituição de peças de desgaste
          natural.
        </p>
        <p class="contract-paragraph">
          Os <span class="bold-words">Planos de Manutenção Premium</span>, além de contemplar os elementos
          correspondentes em cada respectiva
          revisão, contemplam, também, a substituição de algumas peças de desgaste natural, a qualquer momento,
          durante o período de cobertura do plano, tempo ou quilômetros (km) rodados, o que ocorrer primeiro,
          restritos aos seguintes componentes (conforme modelo do Veículo, se equipado): Discos de Freio, Tambores
          de Freio Traseiros, Kit de Lona de Freio, Pastilhas de Freio, Sapatas de Freio de Estacionamento, Disco
          de Embreagem da Transmissão Manual, Mangueira de Retorno do Reservatório de Expansão, Mangueira do
          Aquecedor, Mangueira Superior do Radiador, Mangueira de Retorno do Radiador, Mangueira Inferior do
          Radiador, Mangueiras com Conectores, Mangueira de Retorno de Arrefecimento da Turbina, Mangueira de
          Desvio do Líquido de Arrefecimento Para o Corpo de Borboletas, Correia de Acessórios, Macpherson
          Amortecedor da Suspensão Dianteira, Macpherson Amortecedor da Suspensão Traseira, Cartucho do
          Amortecedor Dianteiro e Cartucho do Amortecedor Traseiro. Nestes casos, a substituição dos itens de
          desgaste natural será determinada pela tolerância de fábrica para a função da peça afetada, conforme
          análise técnica. Os itens cobertos estão restritos aos especificados neste Termo.
        </p>

        <div class="image-paragraph">

          <i class="fas fal fa-exclamation-triangle icon-style"></i>
          <p class="contract-paragraph bold-words">
            <u>Aplicam-se para todos os Planos:</u> Caso haja necessidade de substituição ou reparo de peças
            além das
            indicadas no Plano contratado, o Consultor técnico da Concessionária FORD comunicará, previamente, o
            CONTRATANTE, a fim de que este tenha ciência do que não está contemplado e autorize ou não a
            substituição.
          </p>
        </div>

        <h5 class="contract-paragraph bold-words">
          UTILIZAÇÃO DO PLANO DE MANUTENÇÃO PRÉ-PAGA FORD PROTECT
        </h5>

        <p class="contract-paragraph">
          Para a utilização, gozo e fruição do Plano contratado, o <span class="bold-words">CONTRATANTE</span>
          deverá escolher a Concessionária
          Ford de sua preferência e agendar o atendimento. A lista de Concessionárias Ford poderá ser consultada
          no site <a href="https://www.ford.com.br" target="_blank" rel="noopener">www.ford.com.br</a>, através do
          Centro de Atendimento Ford (“CAF”) através do telefone 0800-703-3673
          ou do aplicativo FordPass.
        </p>
        <p class="contract-paragraph">
          O <span class="bold-words">CONTRATANTE</span> deverá comparecer à Concessionária Ford escolhida munido
          do Certificado de Registro e Licenciamento do Veículo - CRLV e do Manual do Proprietário do Veículo. O
          tempo para a realização dos serviços no veículo pela Concessionária Ford escolhida poderá variar,
          conforme o fluxo de atendimentos em andamento na data agendada pelo <span
            class="bold-words">CONTRATANTE</span>.
        </p>
        <p class="contract-paragraph">
          O encaminhamento do Veículo à Concessionária Ford para realização das revisões periódicas dentro dos
          intervalos definidos é obrigação do <span class="bold-words">CONTRATANTE</span> e essencial para a
          operação correta e segura, bem como para assegurar o melhor desempenho e durabilidade do Veículo.
        </p>
        <p class="contract-paragraph">
          O Plano está vinculado ao número do chassi do Veículo e dele não se dissociará em qualquer hipótese de
          transferência do Veículo pelo <span class="bold-words">CONTRATANTE</span> a terceiros. Sendo assim, o
          terceiro que adquirir o Veículo do
          <span class="bold-words">CONTRATANTE</span> poderá efetuar os serviços remanescentes ainda não
          realizados pelo <span class="bold-words">CONTRATANTE</span>, desde que
          dentro do Período de Vigência do presente Termo e respeitados os intervalos de tempo e quilômetros (km)
          rodados, assim como fará jus ao benefício de 12 (doze) ou 24 (vinte e quatro) meses do Programa Ford
          Assistance (dependendo do plano selecionado), conferido gratuitamente.
        </p>
        <p class="contract-paragraph">
          Em caso de roubo, furto ou perda total, que deverão ser comprovados mediante Boletim de Ocorrência
          policial ou através de documentação do seguro, a <span class="bold-words">FORD</span> devolverá a
          quantia referente aos serviços contratados que não tenham sido realizados, conforme procedimento e
          cálculo de saldo remanescente apurado, conforme descrito na “APURAÇÃO DE SALDO REMANESCENTE”.
        </p>
        <p class="contract-paragraph">
          O <span class="bold-words">CONTRATANTE</span> que não realizar qualquer dos serviços previstos no Plano
          dentro do Período de Vigência do presente Termo e de acordo com os intervalos de tempo e quilômetros
          (km) rodados estabelecidos neste Termo não poderá realizar o serviço perdido fora do prazo estipulado.
          Os serviços posteriores, desde que abrangidos no Plano contratado, poderão ser realizados normalmente,
          resguardado o direito do Contratante de rescindir o Termo e ser
          ressarcido do saldo remanescente nos moldes previstos em “VIGÊNCIA E RESCISÃO”.
        </p>
        <p class="contract-paragraph">
          Independentemente de qual Plano for contratado, a não realização de qualquer das revisões previstas no
          Plano
          de acordo com os intervalos de tempo, quilômetros (km) rodados ou indicação do Monitor Inteligente de
          Vida Útil do Óleo (se equipado) estabelecidos neste Termo e, da mesma forma, a não realização das
          revisões periódicas posteriores ao término do Plano e de acordo com os intervalos de tempo e quilômetros
          (km) rodados conforme Manual do Proprietário do Veículo, poderão ocasionar o cancelamento da garantia do
          Veículo, assim como as demais hipóteses de cancelamento previstas no Manual do Proprietário.
        </p>

        <p class="contract-paragraph bold-words">
          TOLERÂNCIA
        </p>

        <p class="contract-paragraph">
          Como estabelecido no Manual do Proprietário, a tolerância máxima para execução das revisões periódicas,
          é de 1 (um) mês ou 1.000 km para mais ou para menos, conforme abaixo:
        </p>
        <p class="contract-paragraph">
          <u>Para tempo de uso:</u> a tolerância máxima é de 1 (um) mês para mais ou para menos do tempo definido.
          Ex.: entre 11 (onze) e 13 (treze) meses para a manutenção prevista para ocorrer aos 12 (doze) meses de
          uso;
        </p>

        <p class="contract-paragraph">
          <u>Para quilometragem:</u> a tolerância máxima é de 1.000 km para mais ou para menos da quilometragem
          definida. Ex.: entre 9.000 e 11.000 km para a manutenção prevista para ocorrer aos 10.000 km rodados;
        </p>

        <p class="contract-paragraph">
          <u>A tolerância para Veículos Integrados com Monitor Inteligente de Vida Útil do óleo – IOLM</u> deve
          ser consultada no Manual do Proprietário, para execução de troca de cada item.
        </p>

        <p class="contract-paragraph bold-words">
          RESPONSABILIDADE
        </p>

        <p class="contract-paragraph bold-words">
          A FORD não se responsabiliza e não reconhecerá qualquer custo e/ou despesa incorrida com (i) serviços
          realizados pelo CONTRATANTE fora das Concessionárias Ford, cuja relação será periodicamente atualizada e
          publicada no website da FORD ou disponível por meio do CAF; ou (ii) por serviços realizados fora do
          estrito escopo previsto neste Termo.
        </p>
        <p class="contract-paragraph bold-words">
          Em caso de dúvidas sobre os serviços e produtos recomendados à manutenção do Veículo, o CONTRATANTE
          poderá consultar seu Manual do Proprietário. Em caso de conflito entre o Manual do Proprietário e este
          Termo, o CONTRATANTE está ciente que o Plano inclui apenas e tão somente os serviços descritos neste
          Termo e que por sua vez serão realizados conforme indicação de cada revisão.
        </p>

        <h5 class="contract-paragraph bold-words">
          VALORES
        </h5>

        <p class="contract-paragraph">
          Nos valores do plano contratado estão inclusos os serviços e peças indicadas neste Termo, a serem
          incorridas nos intervalos de tempo e quilômetros (km) rodados também indicados neste Termo e conforme
          recomendado pelo Manual do Proprietário, ou, para os itens de desgaste natural, conforme a necessidade
          indicada através do diagnóstico, bem como o valor do serviço de administração de bens e negócios de
          terceiros, conforme plano contratado. O <span class="bold-words">CONTRATANTE</span> declara, neste ato,
          conhecer e aceitar que qualquer
          serviço ou peça adicional não contemplados neste Termo deverão ser pagos separadamente, à Concessionária
          Ford, conforme condições negociadas no momento de sua realização.
        </p>
        <p class="contract-paragraph">
          O valor a ser pago pelo <span class="bold-words">CONTRATANTE</span> inclui todos os custos e despesas
          relacionados com impostos, taxas, tarifas ou quaisquer outros que venham a incidir no âmbito deste Termo
          de Adesão.
        </p>

        <h5 class="contract-paragraph bold-words">
          VIGÊNCIA E RESCISÃO
        </h5>

        <p class="contract-paragraph">
          Este Termo vigorará da data do pagamento integral do plano contratado, até a conclusão do Plano de
          Manutenção contratado, seguindo os seguintes prazos:
        </p>

        <p class="contract-paragraph">
          <span class="bold-words">Ford Protect Revisões Pré-Adquiridas:</span> 12 (doze) meses para cada revisão
          contratada ou mediante a conclusão da
          totalidade dos referidos serviços, o que ocorrer primeiro, respeitados os intervalos de tempo e quilometragem
          previstos no
          Manual do Proprietário ("Período de Vigência");
        </p>

        <p class="contract-paragraph">
          <span class="bold-words">Ford Protect Óleo e Filtro:</span> 12 (doze) meses para cada serviço contratado
          ou
          mediante a conclusão da totalidade dos referidos serviços, o que ocorrer primeiro, respeitados os
          intervalos
          de tempo e quilometragem previstos no Manual do Proprietário ("Período de Vigência");
        </p>

        <p class="contract-paragraph">
          <span class="bold-words">Ford Protect Manutenção Premium (2 anos, 3 revisões ou 60.000 Km):</span> 24
          (vinte e quatro) meses ou mediante a conclusão dos serviços contratados em atingindo a quilometragem
          máxima programada de 60.000 km, o que ocorrer primeiro ("Período de Vigência");
        </p>
        <p class="contract-paragraph">
          <span class="bold-words">Ford Protect Manutenção Premium (2 anos, 4 revisões ou 80.000 Km):</span> 24
          (vinte e quatro) meses ou mediante a conclusão dos serviços contratados em atingindo a
          quilometragem máxima programada de 80.000 km, o que ocorrer primeiro ("Período de Vigência").
        </p>
        <p class="contract-paragraph bold-words">
          Ressalta-se que o presente Termo apenas será considerado vigente e a sua respectiva ativação do Plano de
          Manutenção com o efetivo pagamento integral do preço estabelecido. Em hipótese alguma haverá a
          prorrogação do prazo desta contratação.
        </p>
        <p class="contract-paragraph">
          O <span class="bold-words">CONTRATANTE</span> compreende que, para atender às demandas do Plano, a <span
            class="bold-words">FORD</span> fará investimentos de modo a manter a qualidade de seus serviços e de
          acordo com o cronograma de revisões do Veículo. Caso o <span class="bold-words">CONTRATANTE</span>
          desista do Plano, este poderá rescindir o presente Termo e terá direito a ser ressarcido do saldo
          remanescente (valor pago e não usufruído), conforme cálculo abaixo descrito.
        </p>

        <h5 class="contract-paragraph bold-words">
          APURAÇÃO DE SALDO REMANESCENTE
        </h5>

        <p class="contract-paragraph">
          Para apuração do saldo remanescente do Termo, o valor integral do Plano pago pelo <span
            class="bold-words">CONTRATANTE</span> será dividido igualmente pelo número total de meses ou número
          de revisões/ serviços contratados. Será efetuada a dedução de valores mediante o uso real do Veículo,
          com base na proporção consumida de tempo, contado da data do pedido de cancelamento, ou de revisões/
          serviços efetuados, o que for maior.
        </p>

        <p class="contract-paragraph">
          O valor a ser reembolsado será proporcional ao saldo remanescente do Plano, com base nos meses ou
          revisões faltantes, atualizado pelo IPCA e debitada uma multa administrativa no valor de R$ 50,00
          (cinquenta reais).
        </p>
        <p class="contract-paragraph">
          O pedido de cancelamento deverá ser comunicado à <span class="bold-words">CONCESSIONÁRIA</span> indicada
          no início do presente Termo, momento no qual o <span class="bold-words">CONTRATANTE</span> receberá as
          orientações referentes ao cancelamento.
        </p>
        <p class="contract-paragraph">
          Em qualquer hipótese de desistência do Plano e rescisão do presente Termo, o benefício de 12 (doze) ou
          24 (vinte e quatro) meses do Programa Ford Assistance conferido gratuitamente será imediatamente
          cancelado, permanecendo válidas as disposições do Manual do Proprietário do Veículo quanto aos termos e
          condições do Ford Assistance, inclusive o período de validade.
        </p>

        <h5 class="contract-paragraph bold-words">
          OBRIGAÇÕES DO CONTRATANTE
        </h5>

        <p class="contract-paragraph">
          O <span class="bold-words">CONTRATANTE</span> compromete-se a:
        </p>

        <p class="contract-paragraph">
          (a) observar os direitos e obrigações que lhe são atribuídos pelo Plano escolhido, bem como o Período de
          Vigência, levando, dentro deste período, seu Veículo para efetuar as revisões ou serviços contratados em
          uma Concessionária Ford nos intervalos de tempo, km rodados ou indicação do Monitor Inteligente de Vida
          Útil do Óleo (se equipado), conforme recomendado neste Termo e no Manual do Proprietário;
        </p>

        <p class="contract-paragraph">

          (b) além das revisões ou serviços contratados, efetuar todas as verificações adicionais previstas no
          item
          Manutenção do Manual do Proprietário do Veículo, sendo de responsabilidade do
          <span class="bold-words">CONTRATANTE</span> a realização de itens de revisão não abrangidos pelo Plano
          escolhido;
        </p>

        <p class="contract-paragraph">
          (c) não exigir qualquer reembolso de custos e despesas incorridas em qualquer estabelecimento que não a
          Concessionária Ford, ou ainda de serviços efetuados fora do escopo do presente Termo; e
        </p>
        <p class="contract-paragraph">
          (d) manter seus dados pessoais para contato (nome completo, CPF, e-mail, telefones para contato,
          endereço) atualizados ligando para o CAF ou <span class="bold-words">CONCESSIONÁRIA</span>, de modo a
          possibilitar futuros contatos da
          <span class="bold-words">FORD</span> estritamente relacionados a este Termo.
        </p>

        <h5 class="contract-paragraph bold-words">
          OBRIGAÇÕES DA CONCESSIONÁRIA {{ contractSummary?.dealer.legalName }} E DA REDE DE CONCESSIONÁRIAS FORD
        </h5>

        <p class="contract-paragraph">
          A Concessionária {{ contractSummary?.dealer.legalName }} compromete-se a intermediar a contratação do
          Plano de Manutenção Pré-Paga
          Ford Protect, de modo a esclarecer e orientar o <span class="bold-words">CONTRATANTE</span> sobre todas
          as condições e obrigações objeto deste Termo, permanecendo à disposição para dirimir quaisquer dúvidas
          durante o período de vigência deste Termo, bem como:
        </p>
        <p class="contract-paragraph">
          (a) adotar todas as providências necessárias para ativação do Plano, principalmente o cadastro e envio
          de todos os dados do Cliente à Ford;
        </p>
        <p class="contract-paragraph">
          (b) agendar, mediante contato do <span class="bold-words">CONTRATANTE</span>, data e hora para que o
          <span class="bold-words">CONTRATANTE</span> leve seu Veículo à Concessionária Ford para realização dos
          serviços previstos no Termo;
        </p>
        <p class="contract-paragraph">
          (c) acessar os dados do <span class="bold-words">CONTRATANTE</span> com a finalidade de executar o
          reparo solicitado no veículo, conforme determinado no Plano;
        </p>
        <p class="contract-paragraph">
          (d) cadastrar e atualizar todos os dados do <span class="bold-words">CONTRATANTE</span>, e enviá-los à
          Ford sempre que houver modificação, bem como manter comunicação ativa com a Ford no que se refere às
          peças e aos serviços fornecidos ao <span class="bold-words">CONTRATANTE</span>;
        </p>
        <p class="contract-paragraph">
          (e) abster-se da cobrança de qualquer valor adicional pago pelo <span class="bold-words">CONTRATANTE</span>
          referente a peças e serviços abrangidos pelo presente Termo,
          exceto se o objeto do Termo já tenha sido integralmente cumprido e/ou serviços solicitados estejam fora
          do escopo deste Termo.
        </p>

        <h5 class="contract-paragraph bold-words">
          OBRIGAÇÕES DA FORD
        </h5>

        <p class="contract-paragraph">
          A <span class="bold-words">FORD</span>, durante o Período de Vigência deste Termo, compromete-se a:
        </p>

        <p class="contract-paragraph">
          (a) administrar, para o <span class="bold-words">CONTRATANTE</span>, bens e serviços relacionados ao
          Plano objeto deste Termo;
        </p>
        <p class="contract-paragraph">
          (b) assegurar a qualidade das peças aplicadas e dos serviços previstos neste Termo a serem efetuados no
          Veículo pela Concessionária Ford, nos termos do Plano e do Manual do Proprietário;
        </p>
        <p class="contract-paragraph">
          (c) disponibilizar ao <span class="bold-words">CONTRATANTE</span> canais de atendimento para dirimir
          suas dúvidas, sugestões e reclamações referentes ao Plano;
        </p>
        <p class="contract-paragraph">
          (d) atender, analisar e tomar as medidas que forem cabíveis relativas a toda e qualquer reclamação
          referente a este Termo, bem como contatar a Concessionária Ford quando necessário; e
        </p>
        <p class="contract-paragraph">
          (e) transferir apenas os dados pessoais do <span class="bold-words">CONTRATANTE</span> que sejam
          estritamente necessários para a fruição do Plano para as Concessionárias Ford (ou seja, nome completo,
          CPF, e-mail, telefone para contato, endereço e chassi do Veículo), assegurando que esses serão
          deletados, tanto da base de dados da Ford, quanto da Concessionária Ford, após 10 (dez) anos do término
          do Termo. Fica determinado que os dados pessoais poderão ser armazenados na Ford Cloud, localizada nos
          Estados Unidos, de forma segura e de acordo com as obrigações legais aplicáveis; e que após esse
          período, apenas o chassi do veículo será utilizado para análises estatísticas.
        </p>

        <h5 class="contract-paragraph bold-words">
          DA PROTEÇÃO DE DADOS
        </h5>

        <p class="contract-paragraph">
          Ao fornecer seus dados pessoais, você concorda e fornece o seu consentimento, conforme disposições da
          Lei 13.709/18 para a coleta, tratamento e utilização de seus dados pela <span class="bold-words">FORD</span>,
          bem como com o compartilhamento destes dados com prestadores de serviço relacionados ao Ford Protect e
          transferência internacional para a matriz da Ford nos Estados
          Unidos em razão de infraestrutura tecnológica.
        </p>
        <p class="contract-paragraph">
          A <span class="bold-words">FORD</span> como controladora de seus dados pessoais, assegura ao <span
            class="bold-words">CONTRATANTE</span> que tratará os seus dados em absoluta obediência à sua
          política de privacidade (https://www.ford.com.br/politica-de-privacidade/), bem como que poderá exercer
          todos os seus direitos relacionados aos seus dados pessoais previstos em lei, através do e-mail do DPO
          da <span class="bold-words">FORD</span> (<a href="mailto:dpobrasi&#64;ford.com">dpobrasi&#64;ford.com</a>).
        </p>

        <h5 class="contract-paragraph bold-words">
          DISPOSIÇÕES GERAIS
        </h5>

        <p class="contract-paragraph">
          Toda e qualquer comunicação deverá ser feita através da <span class="bold-words">CONCESSIONÁRIA</span>
          ou do CAF.
        </p>
        <p class="contract-paragraph">
          Os casos fortuitos e de força maior devem ter o tratamento determinado pelo artigo 393 do Código Civil
          Brasileiro.
        </p>
        <p class="contract-paragraph">
          As partes elegem a Comarca do domicílio do <span class="bold-words">CONTRATANTE</span> como competente
          para dirimir eventuais questões oriundas deste Termo. O <span class="bold-words">CONTRATANTE</span>
          poderá, a seu exclusivo critério,
          escolher ajuizar demandas perante o foro da Comarca de São Paulo/SP.
        </p>
        <p class="contract-paragraph">
          O <span class="bold-words">CONTRATANTE</span> afirma e declara que o presente Termo será fisicamente
          impresso e assinado.
        </p>

      </div>

      <div class="col-12 md:col-12 lg:col-11 button-position">
        <button id="btnReturn" class="btn-return" type="button" (click)="buttonComeBack()" [disabled]="blockedUi">
          <i class="pi pi-arrow-left" aria-hidden="true"></i>
          <span class="btn-return-span">{{ 'TRANSLATE.RETURN' | translate }}</span>
        </button>
        <button id="btnSave" class="btn-save" type="submit" (click)="saveContractButton()" [disabled]="blockedUi"
          [attr.aria-busy]="blockedUi">
          @if (!blockedUi) {
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
          }
          @if (blockedUi) {
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
          }
          <span class="btn-save-span">{{ (blockedUi ? 'TRANSLATE.FINISHING' : 'TRANSLATE.FINALIZE') | translate
            }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
}